<template>
    <div :id="id" :style="{ width: width + 'px', height: height + 'px' }"></div>
</template>

<script>
var option = {
    color: ['#FF9A25', '#6E80FF', '#8B69F7', '#3AC421', '#5BAAF9', '#999999'],
    tooltip: {
        trigger: 'item'
    },
    legend: {
        show: false,
        icon: 'rect',
        itemWidth: 8,
        itemHeight: 8,
        orient: 'vertical',
        right: 0,
        top: '12%',
    },
    series: [
        {
            type: 'pie',
            radius: '50%',
            // radius:['0','70%'],
            // center:['35%','40%'],
            label: {
                normal: {
                    show: true,
                    // formatter: '{b} : {d}%'
                }
            },
            data: [
                { value: 1048, name: 'Search Engine' },
                { value: 735, name: 'Direct' },
                { value: 580, name: 'Email' },
                { value: 484, name: 'Union Ads' },
                { value: 300, name: 'Video Ads' }
            ]
        },
    ]
}
export default {
    data () {
        return {
            chart: ''
        }
    },
    props: {
        id: {
            type: String,
            default: 'pie'
        },
        width: {
            type: Number,
            default: 280
        },
        height: {
            type: Number,
            default: 280
        },
        pieData: {
            type: Array
        },
        type: {
            type: String,
            default: 'teacher'
        }
    },
    watch: {
        pieData (val) {
            if (val.length) {
                this.initChart()
            }

        }
    },
    mounted () {
        this.initChart()
    },
    methods: {
        initChart () {
            let that = this
            var chartsDom = document.getElementById(this.id)
            this.chart = this.$echarts.init(chartsDom)
            this.chart.setOption(option)
            window.onresize = that.chart.resize
            if (this.type === 'student') {
                this.chart.setOption({
                    series: [
                        {
                            data: that.pieData,
                            radius: ['0', '70%'],
                            center: ['35%', '52%'],
                            label: {
                                normal: {
                                    formatter: '{b} : {d}%'
                                }
                            },
                        }
                    ],
                    legend: { show: true },
                })
            } else if (this.type === 'student-pie') {
                this.chart.setOption({
                    series: [
                        {
                            data: that.pieData,
                            radius: ['0', '65%'],
                            center: ['35%', '52%'],
                            label: {
                                normal: {
                                    formatter: '{d}%'
                                }
                            },
                        }
                    ],
                    legend: {
                        show: true,
                        orient: 'horizontal',
                        right: 0,
                        top: '50%'
                    },
                })
            } else {
                this.chart.setOption({
                    series: [{ data: that.pieData }]
                })
            }


        }
    }


}
</script>

<style></style>


// WEBPACK FOOTER //
// src/view/Panel/houseworkStatistic/components/Pie.vue